import React from 'react';

import { Page } from '../../../../../shared/ui/Page';
import { PromocodeEdit } from '../containers/PromocodeEdit';

export const PromocodeEditPage = () => {
    return (
        <Page isBackButton title={'Редактирование промокода'}>
            <PromocodeEdit />
        </Page>
    );
};
